import { Component } from "react";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ListBanquesToPayement from "../../../models/ListBanquesToPayement";
import BCService from "../../../services/BC";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import SellingService from "../../../services/SellingService";

class PayementBCEnLigne extends Component {
  state = {
    numeroCard: "",
    amount: "",
    amountMax: "",
    selectedFile: null,
    urlFile: "",
  };

  constructor(props) {
    super(props);
    this.state = {
      numeroCard: "",
      amount: "",
      amountMax: "",
      selectedFile: null,
      urlFile: "",
    };
    this.changeNumeroCarte = this.changeNumeroCarte.bind(this);
    this.changeAmount = this.changeAmount.bind(this);
  }

  changeNumeroCarte(event) {
    this.setState({ numeroCard: event.target.value });
  }

  onFileChangeHandler = (event) => {
    this.setState({
      selectedFile: event.target.files[0],
      loaded: 0,
    });
  };
  UploadFile = () => {
    const dataFile = new FormData();
    dataFile.append("file", this.state.selectedFile);

    // original UploadFileService.uploadFileBill(dataFile).then((res) => {
    //   console.log("name File image", res.data["Bill"]);
    //   this.setState({
    //     urlFile: res.data["Bill"],
    //   });

    //   console.log(res.statusText);
    // });
  };

  payerBill = (e) => {
    if (this.state.amount === "") {
      toast.error("Erreur : le champ montant  est vide");
    } else if (localStorage.getItem("banqueAccount") == null) {
      toast.error("Erreur : le champ compte bancaire est vide");
    } else {
      let payFactureOrAvance = {
        idUser: getCurrentUserId(),
        isFactureOrBDC: 0,
        idDocument: parseInt(localStorage.getItem("idBC")),
        isAvanceOrTotalPayement: 0,

        typePayement: 1,
        urlFile: "any",

        ammountPayed: this.state.amount,

        banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
      };
      if (localStorage.getItem("isIncome") === "ACHAT") {
        BCService.payFactureOrBDC(payFactureOrAvance)
          .then((response) => {
            if (response.data["error"]) {
              toast.error("Error : il ya un probléme");
            } else {
              toast.success("ajouté avec succès");

              window.location.reload(false);
            }
          })
          .catch((error) => {
            toast.error("Error : il ya un probléme");

            window.location.reload(false);
          });
      } else if (localStorage.getItem("isIncome") === "VENTE") {
        SellingService.payFactureOrBDC(payFactureOrAvance)
          .then((response) => {
            if (response.data["error"]) {
              toast.error("Error : il ya un probléme");
            } else {
              toast.success("ajouté avec succès");

              window.location.reload(false);
            }
          })
          .catch((error) => {
            toast.error("Error : il ya un probléme");

            window.location.reload(false);
          });
      }
    }
  };

  changeAmount(event) {
    this.setState({ amount: event.target.value });
  }

  render() {
    return (
      <div className="box-body">
        <br />
        <br />
        <label>Payement En ligne </label>
        <br />
        <ToastContainer />
        <div class="row">
          <div class="col-md-3">
            <label>Montant : </label>
            <input
              className="form-control"
              placeholder="Montant"
              name="amount"
              type="number"
              value={this.state.amount}
              onChange={this.changeAmount}
            />
          </div>

          <div class="col-md-9">
            <label>Compte bancaire</label>
            <ListBanquesToPayement type={1} />
          </div>
        </div>
        <div class="box-footer">
          <button
            style={{ marginTop: 20 }}
            type="submit"
            onClick={this.payerBill}
            className="btn btn-dark float-right"
          >
            Payer
          </button>
        </div>
      </div>
    );
  }
}
export default PayementBCEnLigne;
